import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=50d98b9a&scoped=true"
import script from "./MenuLeft.vue?vue&type=script&lang=js"
export * from "./MenuLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d98b9a",
  null
  
)

export default component.exports